// extracted by mini-css-extract-plugin
export default {"style":"ResultWindow_style__N2E-T","stats":"ResultWindow_stats__qjgQy"};